/**
 * Created by Karol Kluska on 10.11.17.
 */

angular
  .module('app')
  .constant('PAYMENT_STATUSES', {
    NEW: 'new',
    OFFLINE: 'offline',
    PENDING: 'pending',
    CANCELED: 'canceled',
    FAILED: 'failed',
    COMPLETED: 'completed',
    AUTHORIZED: 'authorized',
    REFUNDED: 'refunded',
    UNKNOWN: 'unknown'
  });
